import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Text,
  VStack,
  Box,
  useToast,
  // InputGroup,
  // InputRightElement,
} from "@chakra-ui/react";

// import Input from "../Input/Input";
import Button from "../Button/Button";
import PinInput from "../Input/PinInput";
import { useHistory } from "react-router-dom";

import { useWithdrawMutation } from "../../services/bankApi";
import { useEffect, useState, useCallback, useMemo } from "react";
import useAuth from "hooks/useAuth";
// import { VisibilityOffRounded, VisibilityRounded } from "@material-ui/icons";

const SubmitPin = ({
  data,
  isOpen,
  onClose,
  clearData,
  onSubmit,
  onPin,
  closeOnSubmit,
  closable = true,
}) => {
  const pinMax = 6;

  const history = useHistory();
  const toast = useToast();

  const { profile } = useAuth();

  console.log("USER PROFILE", profile);

  const [pin, setPin] = useState("");
  // const [show, setShow] = useState(false);
  const [, setHasCompleteValues] = useState(false);

  const hasPin = useMemo(() => profile?.data?.hasPin, [profile]);

  const [withdraw, { isLoading, isError, error, isSuccess }] =
    useWithdrawMutation();

  // const handleClick = () => setShow(!show);

  const handlePin = (pin) => {
    const isValid = String(pin).length === pinMax;
    if (!isValid) setHasCompleteValues(false);
    setPin(() => pin);
    onPin && onPin(pin);
  };

  const handleSubmit = useCallback(() => {
    // console.log("WITHDRAW DATA", data);
    console.log("SUBMIT PIN", pin);
    data && withdraw({ ...data, pin });
    onSubmit && onSubmit(pin);
    closeOnSubmit && closeOnSubmit === true && onClose();
    // closeOnSubmit && setPin(null);
  }, [pin, onSubmit, closeOnSubmit, data, onClose, withdraw]);

  const clearForm = useCallback(() => {
    setPin(null);
    clearData && clearData();
    onClose();

    // eslint-disable-next-line
  }, [setPin, onClose]);

  useEffect(() => {
    if (isError) {
      toast({
        position: "bottom-right",
        title: "Oops an error occurred",
        description: error?.data?.error ?? "An unexpected error occurred",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }, [isError, error, toast]);

  useEffect(() => {
    if (isSuccess) {
      clearForm();
      toast({
        position: "bottom-right",
        title: "Success",
        description: "Withdrawal successful",
        status: "success",
        duration: 5000,
        isClosable: true,
        // onCloseComplete: () => {
        //   clearForm();
        // },
      });

      data &&
        data?.currency &&
        history.push(`/dashboard/wallet/${data?.currency}`);
    }

    // eslint-disable-next-line
  }, [isSuccess, toast]);

  const isDisabled = () => isLoading || !pin || pin?.length < 6;

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent borderRadius="30px">
        {closable && <ModalCloseButton top="26px" right="40px" />}
        <ModalHeader textAlign="center" mt="12px !important">
          Enter Pin
        </ModalHeader>
        <ModalBody px="40px">
          <VStack w="100%" alignItems="center" gridGap="10px">
            <Text>Enter your pin</Text>
            <PinInput
              isRequired
              limit={pinMax}
              size={["lg"]}
              onChange={handlePin}
              onComplete={() => setHasCompleteValues(true)}
            />
            {/* <InputGroup>
              <Input
                type={show ? "text" : "password"}
                value={pin ?? ""}
                onChange={(e) => setPin(e.target.value)}
                w="100%"
                placeholder="Enter your pin"
                maxLength={6}
              />
              

              <InputRightElement
                h="100%"
                mr="12px"
                children={
                  <Button
                    bg="transparent"
                    minW="0"
                    size="sm"
                    borderRadius="2"
                    onClick={handleClick}
                  >
                    {show ? (
                      <Box as={VisibilityRounded} color="#A0A3BD" />
                    ) : (
                      <Box as={VisibilityOffRounded} color="#A0A3BD" />
                    )}
                  </Button>
                }
              />
            </InputGroup> */}
            {!hasPin && (
              <Text textAlign="center" fontSize="sm" alignSelf="center">
                (Don't have a pin?{" "}
                <Box
                  as="button"
                  className="pointer green"
                  onClick={() => history.push("/dashboard/account/edit")}
                >
                  Create one
                </Box>
                )
              </Text>
            )}
          </VStack>
        </ModalBody>

        <ModalFooter justifyContent="center" pt="30px" pb="60px">
          <Button
            isLoading={isLoading}
            disabled={isDisabled()}
            onClick={handleSubmit}
            fontWeight="400"
            minH="64px"
            minW="210px"
          >
            Submit
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SubmitPin;
